import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ★追加：画面遷移用のフック
import { API_URL } from '../config';

export default function PasswordChangePage() {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate(); // ★追加：navigate関数を準備

  const changePassword = async () => {
    if (!oldPass || !newPass) {
      setMsg("パスワードを入力してください");
      setError(true);
      return;
    }

    setLoading(true);
    setMsg("");

    try {
      const form = new FormData();
      form.append("action", "changePassword"); 
      form.append("oldPass", oldPass);
      form.append("newPass", newPass);

      const res = await fetch(API_URL, {
        method: "POST",
        body: form,
        credentials: "include",
      });

      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        setMsg("サーバーエラー: 正しい応答が返りませんでした");
        setError(true);
        setLoading(false);
        return;
      }

      if (data.success) {
        setMsg("パスワードを変更しました！次回から新しいパスワードでログインしてください。");
        setError(false);
        setOldPass(""); 
        setNewPass("");
      } else {
        setMsg(data.error || "変更に失敗しました");
        setError(true);
      }
    } catch (err) {
      setMsg("通信エラーが発生しました");
      setError(true);
    }
    
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "400px", margin: "0 auto", marginTop: "40px" }}>
      <h2 style={{ borderBottom: "2px solid #007bff", paddingBottom: "10px", marginBottom: "20px" }}>パスワード変更</h2>

      {msg && (
        <div style={{
          padding: "10px",
          marginBottom: "15px",
          backgroundColor: error ? "#ffcccc" : "#d4edda",
          color: error ? "#d32f2f" : "#155724",
          borderRadius: "5px",
          fontWeight: "bold",
          lineHeight: "1.5"
        }}>
          {msg}
        </div>
      )}

      <div style={{ marginBottom: "15px" }}>
        <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>現在のパスワード</label>
        <input 
          type="password" 
          value={oldPass} 
          onChange={(e) => setOldPass(e.target.value)} 
          style={{ width: "100%", padding: "10px", boxSizing: "border-box", borderRadius: "4px", border: "1px solid #ccc" }}
        />
      </div>

      <div style={{ marginBottom: "25px" }}>
        <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>新しいパスワード</label>
        <input 
          type="password" 
          value={newPass} 
          onChange={(e) => setNewPass(e.target.value)} 
          style={{ width: "100%", padding: "10px", boxSizing: "border-box", borderRadius: "4px", border: "1px solid #ccc" }}
        />
      </div>

      {/* ★修正：ボタンを横並びにするレイアウト */}
      <div style={{ display: "flex", gap: "10px" }}>
        <button 
          onClick={() => navigate(-1)} // 1つ前の画面（メイン画面）に戻る
          disabled={loading}
          style={{ 
            flex: "1", // 幅の比率
            padding: "12px", 
            backgroundColor: "#6c757d", // 落ち着いたグレー
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontWeight: "bold",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer"
          }}
        >
          戻る
        </button>

        <button 
          onClick={changePassword} 
          disabled={loading}
          style={{ 
            flex: "2", // 戻るボタンより少し幅広にする
            padding: "12px", 
            backgroundColor: loading ? "#ccc" : "#007bff", 
            color: "white", 
            border: "none", 
            borderRadius: "4px", 
            fontWeight: "bold",
            fontSize: "16px",
            cursor: loading ? "not-allowed" : "pointer"
          }}
        >
          {loading ? "変更処理中..." : "変更する"}
        </button>
      </div>
    </div>
  );
}